






import { Component, Vue } from 'vue-property-decorator';
import { ListParameters, ListResult } from '@/services/api/nswag/stapiclient_generated';
import ListTable from '@/views/List/ListTable.vue';
import { stListApi } from '@/services/st-api';
import { AccountStore } from '@/store/account-module';
import ListExport from '@/views/List/ListExport.vue';

@Component({
  components: { ListTable, ListExport },
})
export default class ListExternal extends Vue {
  guid: string = '';
  listResult: ListResult = ListResult.fromJS({ rows: [], listParameters: ListParameters.fromJS({ filter: {}, grouping: {}, listSettingsModel: {} }) });
  loading = true;

  created() {
    this.guid = this.$route.params.guid;
  }

  async mounted() {
    this.listResult = await stListApi.getExternal(this.guid);
    await this.$nextTick();
    this.loading = false;
  }
}
